import { render } from "./TermosLegais.vue?vue&type=template&id=164f84fe&scoped=true"
import script from "./TermosLegais.vue?vue&type=script&lang=js"
export * from "./TermosLegais.vue?vue&type=script&lang=js"

import "./TermosLegais.vue?vue&type=style&index=0&id=164f84fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164f84fe"]])

export default __exports__